import React from 'react'

const ProfileLoader = () => {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center' style={{minHeight: "80vh"}}>
        <div className='tutorials_placeholder w-25' style={{height: "35px", borderRadius: "20px"}}></div>
            <div className='p-4 mt-3 rounded col-10 col-md-8 col-lg-6' style={{border: "1px solid #AEAFBA"}}>
                <div className='d-flex flex-column justify-content-start gap-4 rounded'>
                    <div className='tutorials_placeholder col-5' style={{height: "20px"}}></div>
                    <div className='tutorials_placeholder col-2'></div>
                    <div className='tutorials_placeholder col-3'></div>
                    <div className='tutorials_placeholder col-2'></div>
                    <div className='tutorials_placeholder col-4'></div>
                    <div className='tutorials_placeholder col-2'></div>
                    <div className='tutorials_placeholder col-3'></div>
                </div>
            </div>
            <div className='p-4 mt-3 rounded col-10 col-md-8 col-lg-6' style={{border: "1px solid #AEAFBA"}}>
                <div className='d-flex flex-column justify-content-start gap-4 rounded'>
                    <div className='tutorials_placeholder col-4' style={{height: "20px"}}></div>
                    <div className='tutorials_placeholder col-2'></div>
                    <div className='tutorials_placeholder col-1'></div>
                </div>
            </div>
    </div>
  )
}

export default ProfileLoader